import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface UpdateProductGroupRequest {
  id: number;
  name: string;
  status: "ACTIVE" | "PASSIVE" | "FAIL" | "PENDING" | "VOID" | "START" | "SUCCESS" | "REFUND" | "EXPIRED" | "BLOCKED" | "DELETED" | "BLACKLISTED";
}

export type UpdateProductGroupResponse = BaseResponse<null>;

async function updateProductGroup(
  data: UpdateProductGroupRequest
): Promise<UpdateProductGroupResponse> {
  try {
    return (await axiosInstance.put("/Product/UpdateProductGroup", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateProductGroup() {
  return useMutation<UpdateProductGroupResponse, Error, UpdateProductGroupRequest>(
    (variables) => updateProductGroup(variables)
  );
}
